export const generateButtonId = (campaignTitle, context, element) => {
  if (!campaignTitle) return "";

  const sanitize = (str) => {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, "");
  };

  const title = sanitize(campaignTitle);
  return `${title}-${context}-${element}`;
};

export const maintainUtm = (
  buttonId,
  hasInitialParam = false,
  paramsToPreserve = [],
) => {
  const currentUrl = new URL(window.location.href);
  const searchParams = new URLSearchParams(currentUrl.search);
  const preservedParams = Array.isArray(paramsToPreserve)
    ? paramsToPreserve
    : [paramsToPreserve];

  preservedParams
    .filter((param) => Boolean(param))
    .forEach((param) => {
      searchParams.delete(String(param));
    });

  const hasButton = searchParams.has("button");
  const hasButtonId = buttonId !== undefined && buttonId !== null;

  if (!hasButton && hasButtonId) {
    searchParams.set("button", String(buttonId));
  }

  const newSearch = searchParams.toString();

  if (!newSearch) {
    return "";
  }

  if (hasInitialParam) {
    return `&${newSearch}`;
  }

  return `?${newSearch}`;
};

export default maintainUtm;

